import PropTypes from 'prop-types';

export default PropTypes.shape({
  address: PropTypes.string.isRequired,
  emailTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  isPrimary: PropTypes.bool.isRequired,
  isVerified: PropTypes.bool.isRequired,
});
